import React from 'react';
import { cn } from '../../utils/cn';

const styles = {
  info: 'border-blue-200 bg-blue-50 text-blue-800',
  success: 'border-green-200 bg-green-50 text-green-800',
  warning: 'border-yellow-200 bg-yellow-50 text-yellow-800',
  error: 'border-red-200 bg-red-50 text-red-800',
};

export default function Alert({ type = 'info', title, children, className }) {
  return (
    <div className={cn('rounded-lg border p-4', styles[type], className)}>
      {title && <p className="mb-1 font-medium">{title}</p>}
      <div className="text-sm">{children}</div>
    </div>
  );
}
